import { Component, OnInit, Input } from '@angular/core';
import { HotelService } from '../../hotel.service';
import { AlertService } from '../../../../core-lib/services/alerts/alert.service';
import { UtilService } from '../../../util.service';

@Component({
    selector: 'mh-areas-manager',
    templateUrl: './areas-manager.component.html',
    standalone: false
})
export class AreasManagerComponent implements OnInit {
  @Input() customer_id: number;

  hotelAreas: any[] = [];
  hotelAreasLoading = false;

  constructor(
    private hotelService: HotelService,
    private alertService: AlertService,
    private utilService: UtilService,
  ) {}

  ngOnInit() {
    if (this.customer_id) {
      this.loadAreas();
    }
  }

  loadAreas() {
    if (this.customer_id !== 0) {
      this.hotelAreasLoading = true;
      this.hotelService.getAreas(this.customer_id).subscribe({
        next: (response: any[]) => {
          this.hotelAreas = response;
          this.hotelAreasLoading = false;
        },
        error: (error) => {
          console.error('Error loading areas:', error);
          this.hotelAreasLoading = false;
        },
      });
    }
  }

  displayAreaName = (area: any) => {
    if (!area || !area.translates) {
      return '';
    }
    const language = this.utilService.currentLanguage || 'es';
    const translate = area.translates.find((t) => t.language.code === language);
    return translate ? translate.name : area.translates[0]?.name || '';
  };

  toggleAreaActive(area: any) {
    area.active = !area.active;
  }

  saveAreas() {
    this.hotelAreasLoading = true;
    this.hotelService.putAreas(this.customer_id, this.hotelAreas).subscribe({
      next: () => {
        this.hotelAreasLoading = false;
        this.alertService.handleAlert(
          'customer.configurations.hotel.areas.success',
          5000,
          'bottom',
          'end',
          'snackbar-panel-success-user-config',
        );
      },
      error: (error) => {
        console.error('Error saving areas:', error);
        this.hotelAreasLoading = false;
        this.utilService.sendAlert('errors.login.something_went_wrong');
      },
    });
  }
}
